import { render } from "./bill-sum-list.vue?vue&type=template&id=6b0940ca&ts=true"
import script from "./bill-sum-list.vue?vue&type=script&lang=ts"
export * from "./bill-sum-list.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__